import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from '../../../../../../chronusStore/helper';
import { chronusStore } from '../../../../../../chronusStore';
import { eventsListingActions } from '../../../../../../chronusStore/slice/eventsListing';
import ChronusApi from '../../../../../../services/ChronusApi';
import i18n from '../../../../../../utils/ChrI18n';
import { ChrLoader } from '../../../../../../utils/GeneralUtils';
import LoadingRectangle from '../../../../../generic/Utils/LoadingRectangle';
import ChrPaginate from '../../../../../generic/Listing/ChrPaginate';
import Card from './Card';
import Ibox from '../../../../../Ibox';
import { filter } from '../../../../../../utils/CoreExtensions/ObjectExtensions';

const ListView = props => {
  const filters = useSelector(state => state.eventsListing.filters);
  const dispatch = useDispatch();
  const page = useSelector(state => state.eventsListing.page);
  const [data, setData] = useState(null);
  const [shouldFetch, setShouldFetch] = useState(false);
  const [resetPaginate, setResetPaginate] = useState(false);

  useEffect(() => {
    if (shouldFetch) {
      if(data !== null) ChrLoader.show();
      ChronusApi.getUrlJSON(
        props.eventsFetchUrl,
        {
          page: page + 1, // Adding 1 since pagination starts with 0
          ...filter(filters, ([key]) => props.applicableFilters.includes(key)),
          ...props.additionalEventsFetchParams
        }
      ).then(data => {
        window.scrollTo({top: 0, behavior: 'auto'});
        setData(data);
        ChrLoader.hide();
        setShouldFetch(false);
      }).catch(_error => {
        ChrLoader.hide();
        ChronusValidator.ErrorManager.ShowPageFlash(false, i18n.t("common_text.error_msg.something_went_wrong"));
        setShouldFetch(false);
      });
    }
  }, [shouldFetch, page, filters]);

  useEffect(() => {
    dispatch(eventsListingActions.setPage(resetPaginate ? 0 : chronusStore.getState().eventsListing.page)); //Pagination should reset when the filters are changed"
    setShouldFetch(true);
    setResetPaginate(true);
  }, [filters]);

  useEffect(() => {
    setShouldFetch(true);
  }, [page]);

  useEffect(() => {
    initialize.initializeTooltip();
  });

  return(
    <>
      {
        data ? <>
          <div className="clearfix">
            {
              data.events && <span
                className='cur_page_info' dangerouslySetInnerHTML={{__html: data.pagination.pageEntriesInfo}}
              />
            }
            {
              props.globalEventsLink &&
                <a className='float-right' href={ props.globalEventsLink.url }>
                  { props.globalEventsLink.name }
                </a>
            }
          </div>
          {
            data.events ?
              <>
                <div className='mt-3'>
                  {
                    data.events.map(eventDetails => {
                      return <Card
                        key={ eventDetails.id }
                        eventDetails={ eventDetails }
                        showQuickViewOnClick={ props.showQuickViewOnClick }
                      />
                    })
                  }
                </div>

                <ChrPaginate
                  key={ chronusStore.getState().eventsListing.filters.tab }
                  onPageChangeHandler={ event => dispatch(eventsListingActions.setPage(event.selected)) }
                  totalEntries={ data.pagination.totalEntries }
                  perPage={ data.pagination.perPage }
                  forcePage={ page }
                />
              </> :
              <Ibox iboxContentClass='text-center' iboxClass='mt-3'>
                { props.emptyEventsContent }
              </Ibox>
          }
        </> :
        <div className='border cui-border-radius-6 white-bg py-4'>
          <LoadingRectangle />
        </div>
      }
    </>
  );
};

export default ListView;
